import { Route, Routes } from 'react-router-dom';

import CartsPage from '../pages/Cart/Carts';
import { CheckoutPage } from '../pages/Checkout/Checkout';

const CheckoutRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="checkout/:checkoutId" element={<CheckoutPage />} />
        <Route path=":checkoutId" element={<CartsPage />} />
        <Route path="*" element={<CartsPage />} />
      </Routes>
    </>
  );
};

export default CheckoutRoutes;
